import { Customer, GetOptions } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();

const customerRepository =
  repositoryHost.getCustomerRepository(databaseService);

export const useCustomers = (options: GetOptions<Customer>) => {
  return useInfiniteQuery({
    queryKey: ["customers", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      customerRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};
